import { useState, useEffect, useMemo, useRef } from "react";
import { getSnakes, createSnake, deleteSnake } from "../../../api/snakeApi";
import { BsThreeDotsVertical } from "react-icons/bs";
import "./SnakeTable.css";

import useShopItems from "../../../hooks/useShopItems";

export default function SnakeTable({ searchText, selectedFilter }) {
  const [snakes, setSnakes] = useState([]);
  const [openMenu, setOpenMenu] = useState(null);
  const [loading, setLoading] = useState(true);

  const prevLengthRef = useRef(0);
  const isFirstLoad = useRef(true);

  const { fetchSnakeItems, snakeItems, loadingSnakeItems } = useShopItems();

  useEffect(() => {
    const fetchData = async () => {
      let filter = selectedFilter.toLowerCase();
      if (filter === "all") {
        filter = null;
      }
      await fetchSnakeItems(filter);
    };
    fetchData();
  }, [selectedFilter]);

  return (
    <div className="snake-table-container">
      <div className="snake-table-inner">
        {/* HEADER */}
        <div className="snake-table-header">
          <div>SRN</div>
          <div>Name</div>
          <div>Category</div>
          {/* <div>Sub Category</div> */}
          <div>Coins</div>
          <div>Cash</div>
          <div>Added At</div>
          {/* <div>Status</div> */}
          {/* <div className="action-col">Action</div> */}
        </div>

        {/* BODY */}
        <div className="snake-table-body">
          {loadingSnakeItems ? (
            <div className="table-message">Loading...</div>
          ) : !loadingSnakeItems && snakeItems.length === 0 ? (
            <div className="table-message">No items found.</div>
          ) : (
            snakeItems.map((item, index) => (
              <div key={item.id} className="snake-table-row">
                <div>{index + 1}</div>
                <div>{item?.name}</div>
                <div>{item?.type}</div>
                {/* <div>{item.itemSubCategory}</div> */}
                <div>{item.priceCoins}</div>
                <div>{item.priceCash}</div>
                <div className="date">
                  {item.createdAt !== "-"
                    ? new Date(item.createdAt).toLocaleString()
                    : "-"}
                </div>
                {/* <div>
                  <span className="status active">{item.status}</span>
                </div> */}

                {/* ACTION */}
                {/* <div className="action-cell">
                  <button className="menu-btn">
                    <BsThreeDotsVertical />
                  </button>
                </div> */}
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
